<script setup lang="ts">
  import { useGlobalSettingsStore } from '@/stores/GlobalSettings.store'
  import { useMainHeaderStore } from '@/components/main-header/store'
  import type { ISection, ITabs } from '@/components/main-header/types'

  const globalSettingsStore = useGlobalSettingsStore()
  const { globalAlert } = storeToRefs(globalSettingsStore)

  withDefaults(defineProps<{ isIndex?: boolean }>(), { isIndex: false })

  const { isDesktop } = useBTBreakpoints()

  const { locale } = useI18n()

  const { data, error } = await useFetch('/api/storyblok/main-navigation', {
    query: { language: locale.value }
  })

  const tabs = ref<ITabs[]>([])
  const sections = ref<ISection[]>([])

  if (!error.value) {
    tabs.value = (data.value?.tabs as ITabs[]) || []
    sections.value = (data.value?.sections as ISection[]) || []
  } else {
    console.error('Error fetching main navigation data:', error.value)
  }

  const isScrollLocked = useScrollLock(document)

  const mainHeaderStore = useMainHeaderStore()
  watch(
    () => mainHeaderStore.activeSection,
    (value) => (mainHeaderStore.isMenuOpen = !!value)
  )

  watch(
    () => mainHeaderStore.isMenuOpen,
    (value) => (isScrollLocked.value = !!value)
  )
</script>
<template>
  <LazyMainHeaderGlobalAlert
    v-if="globalAlert"
    v-bind="globalAlert"
  />
  <header class="sticky top-0 z-10 border-b border-divider bg-white">
    <UiSkipToContent />
    <div class="relative">
      <MainHeaderTopBar />
      <MainHeaderNavigation
        :header-data="{ tabs, sections }"
        :class="{ hidden: !isIndex }"
      />
      <LazyMainHeaderSectionsDropdown
        v-if="isDesktop"
        v-show="mainHeaderStore.isMenuOpen"
        :active-section="mainHeaderStore.activeSection"
        @close="mainHeaderStore.activeSection = null"
      />
      <LazyMainHeaderMobileSidebar
        v-else
        v-show="mainHeaderStore.isMenuOpen"
        :sidebar-data="{ tabs, sections }"
        @close="mainHeaderStore.isMenuOpen = false"
      />
    </div>
  </header>
</template>
